/** @format */

import React, { useState, useEffect } from "react";
import ImageUpload from "./ImageUpload";
import Checkbox from "@mui/material/Checkbox";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import AddBoxIcon from "@mui/icons-material/AddBox";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Box from "@mui/material/Box";
import SelectDropDown from "./SelectDropdown";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AddProduct = ({ header, productDetails = null, headerLogo = null }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [physicalCheck, setPhysicalCheck] = useState(
    productDetails?.physicalSpec || false
  );
  const [chemicalCheck, setChemicalCheck] = useState(
    productDetails?.chemicalSpec || false
  );
  const [images, setImages] = useState(productDetails?.productImages || []);
  const [productCategories, setProductCategories] = useState([]);
  const [selectedProductCategory, setSelectedProductCategory] = useState(
    productDetails?.category || ""
  );
  const [productSubCategories, setProductSubCategories] = useState([]);
  const [productSubCategory, setProductSubCategory] = useState(
    productDetails?.subCategory || ""
  );
  const [deletedImageList, setDeletedImageList] = useState([]);
  const maxNumber = 5;

  function getProductCategories() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/masterdata/getAllProductCategories`)
      .then((productCategories) => {
        const formatedProductCategory = productCategories.data.list.map(
          (category) => {
            return {
              id: category.id,
              name: category.name,
              value: category.name,
            };
          }
        );
        setProductCategories(formatedProductCategory);
        console.log(formatedProductCategory);
        console.log(productCategories.data.list);
      })
      .catch((err) => console.log(err));
  }

  function getSubCategories() {
    console.log(productCategories);
    const getSelectedProductCategoryData = productCategories.filter((item) => {
      return item.value === selectedProductCategory;
    });
    console.log(getSelectedProductCategoryData);
    const productCategoryId = getSelectedProductCategoryData[0]?.id;
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/masterdata/getProdSubCategoryByCategory?prodCategoryId=${productCategoryId}`
      )
      .then((productSubCategories) => {
        const formatedProductSubCategory = productSubCategories.data.list.map(
          (category) => {
            return {
              id: category.id,
              name: category.name,
              value: category.name,
            };
          }
        );
        setProductSubCategories(formatedProductSubCategory);
        console.log(formatedProductSubCategory);
        console.log(productSubCategories.data.list);
      })
      .catch((err) => console.log(err));
  }

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };

  async function addProduct(data) {
    setLoading(true);
    console.log("add" + data);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/product/addProduct`,
        data,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(response.data)
      setLoading(false);
      navigate("/products")
      toast.success('Product successfully created!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
    } catch (err) {
      toast.error(`${err.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
      setLoading(false);
      console.log(err);
    }
  }

  async function updateProduct(updatedProductData) {
    setLoading(true);
    console.log(images);
    let updatedImageList = images.filter((image) => {
      if (image.file) {
        return image.file;
      }
    });
    console.log(updatedImageList);
    updatedImageList?.forEach((image) => {
      updatedProductData.append("files", image.file);
    });
    console.log("update" + updatedProductData);
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/v1/product/updateProduct`,
        updatedProductData,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(response);
      navigate("/products")
      toast.success('Product successfully updated!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
    } catch (err) {
      toast.error(`${err.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
      console.log(err);
    }
    setLoading(false);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const productData = new FormData();
    const createJson = {
      productName: data.get("product-name"),
      category: data.get("product category"),
      subCategory: productSubCategory,
      productIdentifier: data.get("product-type"),
      productDesc: data.get("product-description"),
      physicalSpec: data.get("physicalSpecification") === "on" ? true : false,
      chemicalSpec: data.get("chemicalSpecification") === "on" ? true : false,
      specificationDet: data.get("specification-details"),
      color: data.get("color"),
      loadUnit: data.get("units"),
      packagingDescription: data.get("packing-description"),
      loadability: data.get("loadability"),
      vendorId: JSON.parse(localStorage.getItem("userId")),
    };
    const updatedProductData = new FormData();
    const updateDataJson = {
      productId: productDetails?.productId,
      productName: data.get("product-name"),
      category: data.get("product category"),
      subCategory: productSubCategory,
      productIdentifier: data.get("product-type"),
      productDesc: data.get("product-description"),
      physicalSpec: data.get("physicalSpecification") === "on" ? true : false,
      chemicalSpec: data.get("chemicalSpecification") === "on" ? true : false,
      specificationDet: data.get("specification-details"),
      color: data.get("color"),
      loadUnit: data.get("units"),
      packagingDescription: data.get("packing-description"),
      loadability: data.get("loadability"),
      vendorId: JSON.parse(localStorage.getItem("userId")),
      deleteImages: deletedImageList,
    };
    console.log({
      productId: productDetails?.productId || null,
      productName: data.get("product-name"),
      category: data.get("product category"),
      subCategory: productSubCategory,
      productIdentifier: data.get("product-type"),
      productDesc: data.get("product-description"),
      physicalSpec: data.get("physicalSpecification") === "on" ? true : false,
      chemicalSpec: data.get("chemicalSpecification") === "on" ? true : false,
      specificationDet: data.get("specification-details"),
      color: data.get("color"),
      loadUnit: data.get("units"),
      packagingDescription: data.get("packing-description"),
      loadability: data.get("loadability"),
      vendorId: JSON.parse(localStorage.getItem("userId")),
    });
    productData.append("json", JSON.stringify(createJson));
    updatedProductData.append("json", JSON.stringify(updateDataJson));
    images.forEach((image) => {
      productData.append("files", image.file);
    });

    productDetails === null
      ? addProduct(productData)
      : updateProduct(updatedProductData);
  };

  useEffect(() => {
    console.log(images);
  }, [images]);

  useEffect(() => {
    console.log(productDetails);
  }, [productDetails]);

  useEffect(() => {
    getProductCategories();
  }, []);

  useEffect(() => {
    if (selectedProductCategory === "") return;
    else getSubCategories();
  }, [selectedProductCategory, productCategories]);

  useEffect(() => {
    console.log(selectedProductCategory);
  }, [selectedProductCategory]);

  // useEffect(() => {
  //   console.log(updatedImageList)
  // }, [updatedImageList])

  useEffect(() => {
    console.log(deletedImageList);
  }, [deletedImageList]);

  return (
    <>
      <Box
        sx={{
          marginTop: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "550px",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          {headerLogo === null ? <AddBoxIcon /> : headerLogo}
        </Avatar>
        <Typography component="h1" variant="h5">
          {header}
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            mt: 1,
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <TextField
            margin="normal"
            required
            id="product-name"
            label="Product Name"
            name="product-name"
            defaultValue={productDetails?.productName}
          />
          <TextField
            margin="normal"
            required
            id="product-id"
            label="Product Type"
            name="product-type"
            defaultValue={productDetails?.productIdentifier}
            InputProps={{
              readOnly: productDetails === null ? false : true,
            }}
          />

          <SelectDropDown
            options={productCategories}
            dropdownLabel="Product Category"
            value={selectedProductCategory}
            setValue={setSelectedProductCategory}
          />
          <SelectDropDown
            options={productSubCategories}
            dropdownLabel="Sub Category"
            value={productSubCategory}
            setValue={setProductSubCategory}
          />

          <TextField
            required
            id="product-description"
            name="product-description"
            label="Product Description"
            multiline
            rows={3}
            variant="filled"
            margin="normal"
            defaultValue={productDetails?.productDesc}
          />

          <FormLabel component="legend" required>
            Product Specs
          </FormLabel>
          <FormControlLabel
            control={
              <Checkbox
                checked={physicalCheck}
                onChange={(e) => setPhysicalCheck(e.target.checked)}
              />
            }
            label="Physical Specification"
            name="physicalSpecification"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={chemicalCheck}
                onChange={(e) => setChemicalCheck(e.target.checked)}
              />
            }
            label="Chemical Specification"
            name="chemicalSpecification"
          />

          <TextField
            margin="normal"
            required
            id="specification-details"
            label="Specification Details"
            name="specification-details"
            defaultValue={productDetails?.specificationDet}
          />
          <TextField
            margin="normal"
            id="color"
            label="Color"
            name="color"
            defaultValue={productDetails?.color}
          />
          <ImageUpload
            listOfImages={images}
            addImageToList={onChange}
            maxLimit={maxNumber}
            deletedImageList={setDeletedImageList}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 1,
              my: 2,
            }}
          >
            <TextField
              fullWidth
              id="loadability"
              name="loadability"
              label="Loadability"
              type="number"
              helperText="numbers only"
              defaultValue={productDetails?.loadability}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              fullWidth
              id="units"
              label="Units"
              name="units"
              helperText="Sets, tonnage Or pieces"
              defaultValue={productDetails?.loadUnit}
            />
          </Box>
          <TextField
            margin="normal"
            id="packing-description"
            label="Packing Description"
            name="packing-description"
            defaultValue={productDetails?.packagingDescription}
          />
          <LoadingButton
            type="submit"
            variant="contained"
            endIcon={<SendIcon />}
            loading={loading}
            loadingPosition="end"
            sx={{ mt: 3, mb: 2, bgcolor: "secondary.main" }}
          >
            {productDetails === null ? "Create Product" : "Update Product"}
          </LoadingButton>
        </Box>
      </Box>
    </>
  );
};
export default AddProduct;
